import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import EbayListingsTable from "../../components/ebayListings/EbayListingsTable";
import { ListedTableStats } from "../../components/ebayListings/listedTable/Stats/ListedTableStats";



export default function EbayListings() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "eBay Listings",
      desc: "View and manage parts that are listed on eBay",
    });
  }, []);

  return (
    <div className="flex flex-col gap-4 mt-4">
      <ListedTableStats />
      <EbayListingsTable />
    </div>
  );
}
